import {
  alertCenteredContainer,
  alertContent,
  alertStyles,
} from "../alerts.css";
import { AlertProps } from "./types";

const Alert = ({
  children,
  icon,
  isCentered,
  isContentCentered,
  isInline,
  isLiveRegion,
  variant = "default",
}: AlertProps) => {
  const alertElement = (
    <div
      className={alertStyles({
        variant,
        // set to true if icon is passed in
        hasIcon: !!icon,
        isContentCentered,
        isInline,
      })}
      role={isLiveRegion ? "status" : undefined}
    >
      {icon && <div>{icon}</div>}
      <span className={alertContent}>{children}</span>
    </div>
  );

  if (isCentered) {
    return <div className={alertCenteredContainer}>{alertElement}</div>;
  }

  return alertElement;
};

export default Alert;
